

import {HttpService} from 'service/HttpService';
import AppConstants from 'AppConstants';

const BASE_URL = AppConstants.BASE_API_URL+"/payment";

class PaymentAPI extends HttpService { 

    signPaymentReq(orderIdList, amount, callback) {
        this.post("/cybersource/sign?amount="+amount, orderIdList, response => {
            const res = response.data;
			callback(true, res);
		}, error => {
			this.defaultErrorHandler(error);
			callback(false, null);
		});
    }
}


export default new PaymentAPI(BASE_URL);


// WEBPACK FOOTER //
// ./src/service/api/PaymentAPI.js